import {AppsyncService} from './AppsyncService'
import gql from "graphql-tag";

import {
    getPayload,
    getPayloadUrlOnly,
    getRequest,
    getRequestDetails,
    listFlowsDynamicSearch,
    listRequestsDynamicSearch,
    listFlowFieldSearch
} from "../../graphql/flow-overview/queries";
import {oktaAuth} from "../config/OktaConfig";

export class StructuredLogsService {

    appsyncService : AppsyncService;

    constructor() {
        this.appsyncService = new AppsyncService(process.env.REACT_APP_APPSYNC_FLOW_OVERVIEW_ENDPOINT!, oktaAuth)
    }

    async getRequest(traceId: string): Promise<any> {
        return this.appsyncService.appSyncClient.query({
                query: gql(getRequest), fetchPolicy: 'network-only', variables: {
                    traceId: traceId
                }
            }
        );
    }

    async getPayload(region: string, bucket: string, key: string, version: string, urlOnly: boolean): Promise<any> {
        return this.appsyncService.appSyncClient.query({
                query: gql(urlOnly ? getPayloadUrlOnly : getPayload),
                fetchPolicy: 'network-only',
                variables: {
                    region: region,
                    bucket: bucket,
                    key: key,
                    version: version
                }
            }
        );
    }

    async getRequestDetails(traceId: string, logType: string): Promise<any> {
        return this.appsyncService.appSyncClient.query({
                query: gql(getRequestDetails), fetchPolicy: 'network-only', variables: {
                    traceId: traceId,
                    logType: logType
                }
            }
        );
    }

    async listRequestForFlow(flowId: string): Promise<any> {
        return this.appsyncService.appSyncClient.query({
                query: gql(listRequestsDynamicSearch), fetchPolicy: 'network-only', variables: {
                    flowId: flowId,
                }
            }
        );
    }

    async listFlows(
        typeList: string[],
        statusList: string[],
        startDate: Date,
        endDate: Date,
        businessReference: string,
        flowId: string,
        detailList: string[],
        shippingPointList: string[],
        inventoryLocationList: string[]
    ): Promise<any> {
        return this.appsyncService.appSyncClient.query({
            query: gql(listFlowsDynamicSearch),
            fetchPolicy: 'network-only',
            variables: {
                typeList: typeList ? typeList : null,
                statusList: statusList ? statusList : null,
                fromTimestamp: startDate ? startDate.getTime() : null,
                toTimestamp: endDate ? endDate.getTime() : null,
                businessReference: businessReference || null,
                flowId: flowId || null,
                detailList: detailList ? detailList : null,
                shippingPointList: shippingPointList ? shippingPointList : null,
                inventoryLocationList: inventoryLocationList ? inventoryLocationList : null
            }
        });
    }

    async listFieldOptions(fieldName: string): Promise<any> {
        return this.appsyncService.appSyncClient.query({
            query: gql(listFlowFieldSearch), fetchPolicy: 'network-only', variables: {
                fieldName: fieldName
            }
        }
    );
    }

}